import { useContext } from 'react'

import { Balance, SessionContext } from '../shared'

export const Header = ({ renderBalance }: { renderBalance: boolean }) => {
  const { publicView } = useContext(SessionContext)

  return (
    <div className='@container flex flex-col gap-4 self-stretch'>
      <div className='flex flex-wrap gap-x-12 gap-y-3 items-center justify-between self-stretch'>
        <h1 className='heading-lg'>
          {publicView ? 'Thatch Marketplace' : 'Marketplace'}
        </h1>
        {renderBalance && (
          <div className='flex flex-row items-center flex-none h-8'>
            <div className='block @lg:hidden'>
              <Balance isLink showFullPrefix={false} />
            </div>
            <div className='hidden @lg:block'>
              <Balance isLink showFullPrefix />
            </div>
          </div>
        )}
      </div>
      <div className='max-w-[680px]'>
        <h4 className='text-gray-500 body'>
          Shop high-impact health products & services at exclusive member prices
        </h4>
      </div>
    </div>
  )
}
